import { getActionAuthorization } from '../commons/utils';

export const TRANSFER_ACTIONS_RESOURCE = {
  CREATE: 'transfer:create',
  EDIT: 'transfer:edit',
  RECEIVE: 'transfer:receive',
  DELETE: 'transfer:delete',
  CHANGE_TRANSFER_DATE: 'transfer:edit:transfer-date',
  CORRECT: 'transfer:correct',

  VIEW: 'transfer:v2:view',
  SEND: 'transfer:v2:send',
  REQUEST: 'transfer:v2:request',
  RECEIVE_V2: 'transfer:v2:receive',
  DELETE_V2: 'transfer:v2:delete',
  CHANGE_STATUS_TO_DRAFT: 'transfer:v2:draft',
  CHANGE_STATUS_TO_INVOICED: 'transfer:v2:invoiced',
  CANCEL_SEND: 'transfer:v2:send:cancel',
  UPDATE_DELIVERY_TIME: 'transfer:v2:update-delivery-time',
  BATCH_CREATION: 'transfer:v2:batch-creation',
};

export const canCreateTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.CREATE);

export const canEditTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.EDIT);

export const canReceiveTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.RECEIVE);

export const canDeleteTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.DELETE);

export const canChangeTransferDate = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.CHANGE_TRANSFER_DATE);

export const canCorrectTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.CORRECT);

export const canViewTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.VIEW);

export const canSendTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.SEND);

export const canRequestTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.REQUEST);

export const canChangeTransferStatusToDraft = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.CHANGE_STATUS_TO_DRAFT);

export const canChangeTransferStatusToInvoiced = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.CHANGE_STATUS_TO_INVOICED);

export const canCancelSendTransfer = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.CANCEL_SEND);

export const canReceiveTransferV2 = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.RECEIVE_V2);

export const canDeleteTransferV2 = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.DELETE_V2);

export const canUpdateDeliveryTime = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.UPDATE_DELIVERY_TIME);

export const canCreateByBatch = (actions) =>
  getActionAuthorization(actions, TRANSFER_ACTIONS_RESOURCE.BATCH_CREATION);
